var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20281",
    "data-name": "Group 20281",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.126,
    height: 16.12,
    viewBox: "0 0 12.126 16.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3900",
    "data-name": "Rectangle 3900",
    width: 12.126,
    height: 16.12,
    fill: "#7c7979"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20280",
    "data-name": "Group 20280",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12782",
    "data-name": "Path 12782",
    d: "M12.124,6.068a6.077,6.077,0,0,1-1.919,4.4c-.225.217-.248.352-.057.6.584.777,1.14,1.574,1.7,2.367.227.32.2.374-.186.412-.567.056-1.133.119-1.7.164a.483.483,0,0,0-.463.341c-.191.5-.4.986-.6,1.477-.044.105-.058.266-.176.285-.147.023-.2-.147-.267-.246-.721-1-1.447-1.993-2.151-3-.193-.276-.291-.261-.476,0-.714,1.019-1.452,2.021-2.17,3.037-.189.268-.292.283-.414-.044-.186-.5-.4-.982-.593-1.479a.525.525,0,0,0-.519-.378C1.567,13.973,1,13.9.434,13.851c-.313-.026-.349-.137-.169-.384.587-.807,1.157-1.626,1.752-2.427.169-.228.141-.35-.056-.545A5.815,5.815,0,0,1,.309,4.274,5.826,5.826,0,0,1,5.236.073,6.07,6.07,0,0,1,12.045,5.1a5.376,5.376,0,0,1,.079.969M8.449,14.231c.055-.052.1-.074.1-.1.152-.865.731-1.125,1.527-1.089.265.012.24-.11.117-.278-.382-.523-.758-1.051-1.138-1.575-.448-.617-.448-.616.133-1.094A5.093,5.093,0,1,0,1.125,7.285a5.239,5.239,0,0,0,2.049,2.978c.311.227.3.4.083.686-.421.542-.809,1.109-1.211,1.666-.275.38-.276.426.181.433.68.011,1.171.2,1.3.949.041.235.155.266.313.042.582-.826,1.175-1.644,1.766-2.464.469-.65.468-.647.933,0,.631.882,1.267,1.76,1.909,2.65",
    transform: "translate(0.001 -0.001)",
    fill: "#7c7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12783",
    "data-name": "Path 12783",
    d: "M45.5,35.121a4.643,4.643,0,0,0-.028,3.049.21.21,0,0,1-.153.273,2.912,2.912,0,0,1-.293.1,4.359,4.359,0,0,0-2.244,1.309c-.207.226-.4.263-.606.008-.032-.04-.079-.068-.112-.107a3.975,3.975,0,0,0-2.228-1.238c-.318-.073-.433-.229-.314-.555a3.77,3.77,0,0,0,0-2.651c-.116-.319-.02-.494.307-.558.051-.01.1-.034.149-.044a3.659,3.659,0,0,0,2.163-1.268c.23-.27.433-.266.661,0a4.117,4.117,0,0,0,2.315,1.317c.177.039.408.075.382.362m-1.12.625c.039-.2-.1-.25-.245-.285a2.581,2.581,0,0,1-1.449-.836.242.242,0,0,0-.421,0,2.421,2.421,0,0,1-1.417.811.271.271,0,0,0-.229.4,2.29,2.29,0,0,1,0,1.591.274.274,0,0,0,.216.409,2.715,2.715,0,0,1,1.475.872.194.194,0,0,0,.327,0,3.053,3.053,0,0,1,1.524-.872c.15-.036.262-.115.21-.3a2.843,2.843,0,0,1,.006-1.79",
    transform: "translate(-36.405 -30.656)",
    fill: "#7c7979"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.75363313568167eaf00f01f24bf42053.svg";
export { ForwardRef as ReactComponent };